import { gql } from '@apollo/client';

export const getConsultaAdhesionComercios = gql`
query AdhesionComerciosApi{
    consultaAdhesionComercios(cuit:$cuit)  
    @rest(type: "consultaAdhesionComercio", path: "/api/gateway/formulariosComercios/presolicitud/{args.cuit}/consulta"){
        cuit
        email
        denominacion
        domicilioLegal
        sucursal
        tipoPersona
        esCliente
        error
        estado   
    }
}
`   